import React from "react";
import { View } from "react-native";
import { colors } from "src/assets";

const htmlSting = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Untitled Document</title>
<!-- Bootstrap -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
</head>
<body>
<!-- body code goes here -->
<div class="container p-3">
    <h2 class="mb-3">振込申請手数料</h2>
    <table class="table-bordered w-100">
        <tr>
            <td class="bg-light text-center p-1 small" rowspan="2"></td>
            <td class="bg-light text-center p-1 small" colspan="3">振込先</td>
        </tr>
        <tr>
            <td class="bg-light text-center p-1 small"><b>楽天銀行</b></td>
            <td class="bg-light text-center p-1 small" colspan="2"><b>楽天銀行以外</b></td>
        </tr>
        <tr>
            <td class="bg-light text-center p-1 small"></td>
            <td class="bg-light text-center p-1 small"></td>
            <td class="bg-light text-center p-1 small">3万円未満</td>
            <td class="bg-light text-center p-1 small">3万円以上</td>
        </tr>
        <tr>
            <td class="bg-light p-1 small">A. 口座確認手数料</td>
            <td class="text-center p-1 small" colspan="3">110円</td>
        </tr>
        <tr>
            <td class="bg-light p-1 small">B. 振込手数料</td>
            <td class="text-center p-1 small">105円</td>
            <td class="text-center p-1 small">150円</td>
            <td class="text-center p-1 small">229円</td>
        </tr>
        <tr>
            <td class="bg-light p-1 small"><b>合計（A＋B）</b></td>
            <td class="text-center p-1 small"><b>162円</b></td>
            <td class="text-center p-1 small"><b>260円</b></td>
            <td class="text-center p-1 small"><b>339円</b></td>
        </tr>
    </table>
    <ul class="pl-3 pt-3">
        <li>口座確認手数料は、振込申請の結果に関わらず発生致します。</li>
        <li>前回と同じ口座に振り込む場合は、口座確認手数料は発生致しません。</li>
        <li>口座確認手数料・振込手数料についての詳細は<a href="https://www.rakuten-bank.co.jp/business/howto/interest.html#anchor-06" target="_blank">こちら</a>。</li>
        <li>振込先銀行口座の問題で振込結果がエラーとなった場合、合計（A+B）に組戻手数料（660円）が加算されます。</li>
    </ul>
</div>

<script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>
</body>
</html>`;

export type WithdrawalDescriptionNavigationParam = undefined;

export const WithdrawalDescriptionScreen: React.FC = () => {
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: colors.white,
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: htmlSting }} />
    </View>
  );
};
